export default __webpack_public_path__ + "static/media/arrowExport.ac705b1c.svg";